import { DateTime } from 'luxon'

export enum RevenueTrackingActionTypes {
  SET_REPORTS_DATA = 'SET_REPORTS_DATA',
  REVENUE_SET_PAGE_NUMBER = 'REVENUE_SET_PAGE_NUMBER',
  REVENUE_SET_LIMIT = 'REVENUE_SET_LIMIT',
  SET_PRODUCT_ID = 'SET_PRODUCT_ID',
  CLEAR_REVENUE_REPORTS = 'CLEAR_REVENUE_REPORTS',
  SET_DATE_RANGE = 'SET_DATE_RANGE',
}

export enum ReportType {
  DAILY = 'daily',
  MONTHLY = 'monthly',
  CLOUD_DISBURSEMENT = 'cloudDisbursement',
  DISBURSEMENT = 'disbursement',
}

export interface GraphData {
  date: string
  totalAmountActivated?: number
  totalAmountBilled?: number
  totalAmountDisbursed?: number
}
export interface DateRange {
  startDate: string
  endDate: string
}
export interface ReportsRow {
  date: string
  productTitle: string
  labraProductId: string
  cloudMarketplaceProductCode: string
  labraBuyerName: string
  offerId: string
  buyerId: string
  labraBuyerLogoUrl: string
  awsAccountId: string
  activatedAmount?: string
  billedAmount?: string
  revenue?: string
  deductions?: string
  refund?: string
  disbursedAmount?: string
}

export interface CloudDisbursementReportsRow {
  settlementId: string
  settlementPeriodStartDate: string
  settlementPeriodEndDate: string
  depositDate: string
  disbursedAmount: string
  requestedForDatetime: string
}

export interface ReportsData {
  rows: ReportsRow[] | CloudDisbursementReportsRow[]
  totalAmountActivated?: string
  amountChange?: string
  percentageChange?: string
  totalAmountBilled?: string
  totalAmountDisbursed?: string
  pageSize: number
  pageNumber: number
  noOfPage: number | null
  graphData: GraphData[]
  dateRange: DateRange
}
export interface ReportsPayload {
  rows: ReportsRow[]
  totalAmountActivated?: string
  totalAmountBilled?: string
  totalAmountDisbursed?: string
  count: number
  pageSize: number
}

export const initialRevenueInsightsState: ReportsData = {
  rows: [],
  totalAmountActivated: '',
  totalAmountBilled: '',
  totalAmountDisbursed: '',
  pageSize: 10,
  pageNumber: 1,
  noOfPage: null,
  graphData: [],
  dateRange: {
    startDate: DateTime.now().toISODate() as string,
    endDate: DateTime.now().toISODate() as string,
  },
}

export type RevenueInsightsAction =
  | {
      type: RevenueTrackingActionTypes.SET_REPORTS_DATA
      payload: ReportsPayload
    }
  | {
      type: RevenueTrackingActionTypes.REVENUE_SET_PAGE_NUMBER
      payload: number
    }
  | {
      type: RevenueTrackingActionTypes.REVENUE_SET_LIMIT
      payload: number
    }
  | {
      type: RevenueTrackingActionTypes.CLEAR_REVENUE_REPORTS
    }
  | {
      type: RevenueTrackingActionTypes.SET_DATE_RANGE
      payload: DateRange
    }

export type RevenueInsightsState = {
  daily: ReportsData
  monthly: ReportsData
  disbursement: ReportsData
  cloudDisbursement: ReportsData
}
